import Swiper from "swiper";
import { A11y, EffectFade, Navigation } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const pageHeader = document.querySelector(".page-header");
  const container = pageHeader.querySelector(".swiper");

  if (!container) {
    return;
  }

  new Swiper(container, {
    modules: [A11y, EffectFade, Navigation],
    speed: 500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: pageHeader.querySelector(".slider-button-next"),
      prevEl: pageHeader.querySelector(".slider-button-prev"),
    },
  });
});
